export default class DuplicateReportRequest {
    fromDate: string;
    toDate: string;
    groupByMonth: boolean;
}
